import { render, staticRenderFns } from "./purchaseordernew.vue?vue&type=template&id=0b78b7a6&scoped=true&"
import script from "./purchaseordernew.vue?vue&type=script&lang=js&"
export * from "./purchaseordernew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78b7a6",
  null
  
)

export default component.exports